<template>
<div class="container no-padding">
  <div class="loader" v-if="loading"><img src="/img/loader.svg" alt="" /></div>
  <div class="content pb30" style="margin-top:0;">
    <div class="white-bg-block h880 success-block">
      <img src="/img/checkbox.svg" alt="" style="width:100px; height: 100px;" />
      <span class="fs36 bold" style="color:#fff;">Спасибо за покупку!</span>
      <span style="color:#fff;line-height:25px;font-size:18px;font-weight:normal;">Холодильник закроется <br />автоматически через</span>
      <span style="color:#fff;" class="fs36 bold">{{delay}}</span>
      <!-- <a href="#" @click.prevent="close()" class="btn">Вернуться на главный экран</a> -->
      <div class="qr-code">
        <qrcode :value="qr_code_url" :options="{ width: 130 }"></qrcode>
      </div>
      <span style="color:#fff;line-height:25px;font-size:18px;font-weight:normal;margin-top: 20px;">Для получения чека<br/>отсканируйте QR-код</span>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'Success',
  data() {
    return {
      qr_code_url: '',
      delay: 10,
      loading: false,
    };
  },
  created() {
    this.qr_code_url = 'https://terminal.briskly.online/receipt/?order_key=' + this.$route.params.order_key;
    var elem = this;
    setInterval(function() {
      if (elem.delay > 0) {
        elem.delay--;
      }
    }, 1000);
    setTimeout(function() {
      elem.close();
    }, 10000);
  },
  mounted() {},
  methods: {
    close() {
      this.loading = true;
      this.$store.state.order = {};
      this.$store.state.isAuthorized = false;
      this.$router.push('/');
    },
  },
};
</script>

<style>
.content {
  padding-top: 15vh;
}
</style>
